import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { NgxPaginationModule } from 'ngx-pagination';

import { PaginatorDarkModule } from '@core/layout/components/paginator/dark/dark.module';

import { SharedModule } from '@shared/shared.module';

import { ArticleSearchBarModule } from '../search-bar/search-bar.module';
import { ArticleSearchResultsComponent } from './search-results.component';

@NgModule({
  declarations: [ArticleSearchResultsComponent],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    NgxPaginationModule,
    PaginatorDarkModule,

    ArticleSearchBarModule,
    SharedModule,
  ],
  exports: [ArticleSearchResultsComponent],
})
export class ArticleSearchResultsModule {}
